import {Tooltip, Typography} from "@mui/material";

interface MaderaColumnHeaderProps {
    label: string;
    tooltip: string;
}

export const MaderaColumnHeader: React.FC<MaderaColumnHeaderProps> = ({label, tooltip}) => {
    return (
        <Tooltip title={tooltip} arrow>
            <Typography
                component="span"
                sx={{
                    textTransform: "uppercase",
                    fontWeight: 500,
                    fontSize: "0.75rem",
                    display: "inline-block",
                }}
            >
                {label}
            </Typography>
        </Tooltip>
    );
};
